import { css } from "styled-components";
import { COLOR_SCHEME_LIGHT } from "theme/constants";
const SIZE = 5;
const shadowXY = (side) => {
  switch (side) {
    case "left":
      return { x: -4, y: 0 };
    case "right":
      return { x: 4, y: 0 };
    case "top":
      return { x: 0, y: -4 };
    case "bottom":
      return { x: 0, y: 4 };
  }
};
const sideGeometry = (side) => {
  switch (side) {
    case "left":
      return css`
        left: 0;
        top: 0;
        bottom: 0;
        width: ${SIZE}px;
      `;
    case "right":
      return css`
        right: 0;
        top: 0;
        bottom: 0;
        width: ${SIZE}px;
      `;
    case "top":
      return css`
        top: 0;
        left: 0;
        right: 0;
        height: ${SIZE}px;
      `;
    case "bottom":
      return css`
        bottom: 0;
        left: 0;
        right: 0;
        height: ${SIZE}px;
      `;
  }
};
const ScrollShadow = (side) => {
  const { x, y } = shadowXY(side);
  return css`
    &::before {
      content: '';
      position: absolute;
      pointer-events: none;
      z-index: -1;
      box-shadow: ${x}px ${y}px 8px rgb(0 0 0 / ${({ theme }) => theme.mode === COLOR_SCHEME_LIGHT ? "10%" : "40%"});
      ${sideGeometry(side)}
    }
  `;
};
export default ScrollShadow;
